import React, { ReactComponentElement, useState } from "react";
import classNames from "classnames";
import { useHistory } from "react-router-dom";

import { ListingTableRowProps } from "./listing-table-row.types";
import { useListingTableStyles } from "../listing-table.styles";
import { ListingTableNoResults } from "../listing-table-no-results/listing-table-no-results.component";
import { TableCell, TableRow } from "@material-ui/core";
import { makeKey } from "../../../../utils/helpers";
import { ListingTableMidHeader, TCol, TRow } from "../listing-table.types";
import { ListingTableHeaderRow } from "../listing-table-header-row/listing-table-header-row.component";

export const ListingTableRow = (props: ListingTableRowProps) => {
  const classes = useListingTableStyles();
  const history = useHistory();

  const [entireRowFocused, setEntireRowFocused] = useState(false);

  if (props.dataList.length === 0) {
    return (
      <ListingTableNoResults columns={props.columns.length} message={props.noResultsMessage} />
    );
  }

  const rowClasses = classNames({
    [classes.row]: true,
    [classes.rowPointer]: props.link,
  });

  const handleRowClick = (row: TRow) => {
    if (props.link) {
      props.close && props.close();
      history.push(props.link(row));
    }
  };

  const renderRowCell = (col: TCol, row: TRow): string | ReactComponentElement<any> => {
    if (typeof col.render === "function") {
      return col.render(row, props.link) ?? `FUNC_FAIL (${row?.id})`;
    }

    return row[col.key] ?? `NO_KEY: "${col.key}" (${row?.id})`;
  };

  const stopPropagation = (stop: boolean) => (e: React.MouseEvent) => {
    if (stop) {
      e.stopPropagation();
    }
  };

  return (
    <>
      {props.dataList.map((row, ri) => {
        if (!!row[ListingTableMidHeader]) {
          return <ListingTableHeaderRow columns={props.columns} key={ri} row={row} />;
        }

        return (
          <TableRow
            tabIndex={0}
            className={rowClasses}
            key={ri}
            onClick={() => handleRowClick(row)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && entireRowFocused === true) {
                handleRowClick(row);
              }
            }}
            onFocus={() => {
              setEntireRowFocused(true);
            }}
            onBlur={() => {
              setEntireRowFocused(false);
            }}
          >
            {props.columns.map((col, ci) => {
              const comp = ci === 0 ? "th" : "td";
              return (
                <TableCell
                  className={classes.rowCell}
                  key={makeKey(ri, ci)}
                  component={comp}
                  scope="row"
                  onClick={stopPropagation(!!col.stopPropagation)}
                  onFocus={(e) => {
                    e.stopPropagation();
                  }}
                  style={{
                    minWidth:
                      props.minFirstColumnWidth && ci === 0 ? props.minFirstColumnWidth : "none",
                  }}
                >
                  <div className={classes.rowText}>{renderRowCell(col, row)}</div>
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </>
  );
};
